import { useEffect } from 'react';
import { useMap } from '@/state/context/MapContext';
import { Layer } from 'ol/layer';

export default function useMapLayer({ layer, index }: { layer: Layer; index?: number }) {
    const { map } = useMap();

    useEffect(() => {
        if (!map) {
            return;
        }

        map.addLayer(layer);

        return () => {
            map.removeLayer(layer);
        };
    }, [layer, map]);

    useEffect(() => {
        layer.setZIndex(index ?? 1001);
    }, [index, layer]);
}
